import { Link } from "react-router-dom";
import { useApplication } from "../../contexts/ApplicationContext";

/*
  Link para a ficha ou para a tabela de clientes, que o operador não abre.

  Sem isto cada tela que cita uma conta teria um link que leva de volta para
  "Hoje" sem explicar nada. Para o operador, o nome da conta vira texto (ele
  continua precisando ler a quem aquilo se refere) e o que é só atalho para a
  ficha, sem conteúdo próprio, some com `hideWhenBlocked`.
*/
const ClientLink = ({ to, className = "", hideWhenBlocked = false, children, ...rest }) => {
  const { isOperator } = useApplication();

  if (isOperator) {
    if (hideWhenBlocked) return null;

    return (
      <span className={className.replace(/\bhover:\S+/g, "").trim()}>
        {children}
      </span>
    );
  }

  return (
    <Link to={to} className={className} {...rest}>
      {children}
    </Link>
  );
};

export default ClientLink;
